import { Component, inject } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PrintData } from '../../model';
import { PrintService } from '../../services/print-service';

@Component({
  selector: 'app-print-component',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIcon,
    MatButtonModule
  ],
  templateUrl: './print-component.html',
  styleUrl: './print-component.css',
})
export class PrintComponent {
  readonly dialogRef = inject(MatDialogRef<PrintComponent>);
  readonly data = inject<PrintData>(MAT_DIALOG_DATA);
  // recupere les donnees envoyes par le parent

  pdfFile !: SafeResourceUrl

  printService = inject(PrintService)

  constructor(
        private sanitizer: DomSanitizer
  ){}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    const blobUrl = URL.createObjectURL(new Blob([this.data.dataBlob!], { type: 'application/pdf' }))
    this.pdfFile = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);

    if(this.data.timeout)
      setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
  }

  printDetails(){
    switch (this.data.detail) {
      case 'contrat-assurance':
        this.printService.imprimer(this.data.assurance, true)
        break;
      case 'recu-assurance':
        this.printService.imprimerRecu(this.data.assurance, true)
        break;
      case 'attestation-assurance':
        this.printService.imprimerAttestation(this.data.assurance, true)
        break;
      case 'carte-rose-assurance':
        this.printService.imprimerCarteRose(this.data.assurance, true)
        break;
    
      default:
        break;
    }
  }

}
